import NoticeEdit from "./edit.vue";
import NoticeList from './list.vue'
let a = Object.assign({NoticeEdit, NoticeList}, {})
export default a;
